import {ADD_PRODUCT, SET_PRODUCTS, UPDATE_PRODUCT} from '../actionTypes';
import {IFarmInputProduct} from 'constants/interfaces';

export type ProductState = {lastUpdate: number; products: IFarmInputProduct[]};
const initialState: ProductState = {lastUpdate: 0, products: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_PRODUCTS: {
      const products: IFarmInputProduct[] = action.payload || [];
      const stateUpdate: ProductState = {
        lastUpdate: new Date().getTime(),
        products: products.map((product) => ({...product})),
      };
      return stateUpdate;
    }

    case UPDATE_PRODUCT: {
      const productUpdate: IFarmInputProduct = action.payload;
      if (!productUpdate) return state;

      const stateUpdate: ProductState = {
        lastUpdate: state.lastUpdate,
        products: state.products.map((product) => {
          if (product.id === productUpdate.id) return {...productUpdate};
          return product;
        }),
      };
      return stateUpdate;
    }

    case ADD_PRODUCT: {
      const product: IFarmInputProduct = action.payload;
      if (!product) return state;
      const stateUpdate: ProductState = {
        lastUpdate: state.lastUpdate,
        products: [...state.products, product],
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
